export const isMobileDevice = () => {
  const userAgents = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];
  return userAgents.some(ua => navigator.userAgent.match(ua));
};
export const getDevice = () => {
  const tabletUserAgents = [/Tablet/i, /iPad/i, /SM-T/i];
  const mobileUserAgents = [/Android/i, /webOS/i, /iPhone/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];
  if (tabletUserAgents.some(ua => navigator.userAgent.match(ua))) {
    return 'tablet';
  }
  if (mobileUserAgents.some(ua => navigator.userAgent.match(ua))) {
    return 'mobile';
  }
  return 'desktop';
};
